import InfoCard from '../../../components/info-card'

export default function SellingInfo() {
  return (
    <div className='sellInfo'>
      <h2>Our Selling Process</h2>
      <img className='kbb' src='/images/kbb.png' alt='kbb' />

      <InfoCard>
        <div className='imageContainer flex justifyCenter'>
          <img src='/images/red-car.png' alt='red car' width='880' height='510' />
        </div>
        <aside>
          <h3>Retail money with wholesale simplicity!</h3>
          <p>
            No more low ballers, spammers or con artists. No more wholesale values meant for someone
            else to resell your vehicle. Drivrzxchange is a transparent and safe platform created to
            assist you in selling your next vehicle, without all of the hassles typically associated
            with selling privately.
            {`${process.env.NEXT_PUBLIC_KBB_ISENABLED}` == 'True'
              ? ` The best deal is a fair deal, and that’s why we decided to
                        provide all sellers with the Kelley Blue Book guide values for private party
                        transactions. `
              : ` `}
            You can list with confidence that you will receive a fair amount for your vehicle, a
            much better option than selling it wholesale.
          </p>
        </aside>
      </InfoCard>

      <style jsx>{`
        .sellInfo {
          position: relative;

          h2 {
            margin: 0 0 2.1rem;
            text-align: center;
            font-size: 5.4rem;
          }

          .imageContainer {
            max-width: 101.7rem;
            width: 100%;
            min-height: 62.3rem;
            background: linear-gradient(180deg, #fff, rgba(255, 255, 255, 0));

            img {
              width: 100%;
              height: 100%;
              padding: 5rem 7rem;
              object-fit: contain;
            }
          }

          aside {
            max-width: 51.3rem;
            padding: 5.2rem 7.5rem 5.2rem 7.3rem;
          }

          h3 {
            margin: 0 0 0.7rem;
            line-height: 3.6rem;
            font-size: 3.2rem;
          }

          p {
            line-height: 3rem;
            font-size: 2.2rem;
          }

          .kbb {
            position: absolute;
            left: 5.2rem;
            z-index: 1;
            max-width: 12.3rem;
            width: 10vw;
            height: auto;
          }

          :global(.wrapper aside) {
            padding: 5.3rem 7.5rem 5.2rem 7.3rem;
          }
        }

        @media (max-width: 1024px) {
          .sellInfo {
            h2 {
              margin: 0 0 1.3rem;
              font-size: 2rem;
            }

            .imageContainer {
              min-height: unset;
              max-width: 100%;

              img {
                padding: 1.6rem 4.3rem;
              }
            }

            aside {
              max-width: 100%;
              padding: 2.6rem 2.4rem;
            }

            h3 {
              margin: 0 0 1rem;
              line-height: 1.8rem;
              font-size: 1.4rem;
            }

            p {
              line-height: unset;
              font-size: 1.4rem;
            }

            .kbb {
              right: 4.3rem;
              width: 5.2rem;
            }

            :global(.wrapper aside) {
              padding: 2.6rem 2.6rem 2.4rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
